module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--not-found main--full-height"
  }, [_c('div', {
    staticClass: "group group--narrower group--last"
  }, [_c('h1', {
    staticClass: "h1",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("We’re sorry, but the page you have tried to access does not exist.")]), _vm._v(" "), _c('module-button', {
    attrs: {
      "link": "home",
      "label": "Return to the homepage"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7606da8d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/base/404.vue
// module id = 405
// module chunks = 0